module.exports = __webpack_public_path__ + "static/img/bg-form.75f497f3.jpg";